<template>
  <CustomSelect
    class="w-100"
    inputId="groupClassStatusPicker"
    :inputLabel="inputLabel"
    v-model="selectedGroupClassStatus"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="classGroupStatuses"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedStatus: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String],
      default: "وضعیت کلاس گروهی",
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedStatus) {
      this.selectedGroupClassStatus = this.defaultSelectedStatus;
    }
  },
  data() {
    return {
      selectedGroupClassStatus: 0,
      classGroupStatuses: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "جدید",
          value: 0,
        },
        {
          text: "در انتظار تایید",
          value: 1,
        },
        {
          text: "در حال ثبت نام",
          value: 2,
        },
        {
          text: "اتمام ظرفیت",
          value: 3,
        },
        {
          text: "کنسل شده",
          value: 4,
        },
        {
          text: "به اتمام رسیده",
          value: 5,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
